module.exports = __webpack_public_path__ + "img/single-woman.c16f951b.svg";